export const coursesES = {
  unit: 'Unidad {{value}}',
  units: 'Unidades',
  title: 'Selecciona el paquete y comienza el curso!',
  inscription: 'Inscribiendo en el curso..',
  sidebar: {
    classes: 'Clases Online'
  }
}
